import React, { useState } from "react";
import FileFullView,{ imagetype } from "./FileFullView";
import { DocIcon, ImageIcon, PdfIcon, TxtIcon, XlsxIcon } from "../assets/icons";

export default function IconDisplay({ data,view }) {
  const [show, setShow] = useState(true);
  const [showFile, setShowFile] = useState(false);
  const handleClose = () => setShowFile(false);
  let ImgPath = data?.split(".").reverse()[0];
  return (
    <>
      { show && (<>
      <div className="text-center w-10 " onClick={() => {
            setShowFile(!showFile)
          }}>
        <div
          className=" w-10 h-10 bg-tableodd rounded-lg group relative cursor-pointer flex justify-center items-center"
        >
          {imagetype.includes(ImgPath) ? (
            <ImageIcon width="25px" height="25px" />
          ) : ImgPath == "docx" ? (
            <DocIcon width="30px" height="30px"/>
          ) : ImgPath == "doc" ? (
            <DocIcon width="30px" height="30px"/>
          ) : ImgPath == "xlsx" ? (
            <XlsxIcon width="25px" height="25px"/>
          ) : ImgPath == "txt" ? (
            <TxtIcon width="25px" height="25px"/>
          ) : ImgPath == "pdf" ? (
            <PdfIcon width="30px" height="30px"/>
          ) : null}
        </div>
      </div>
      </>)
      }
      {view && <FileFullView path={data} 
      onClose={handleClose}
      visible={showFile}/>}
    </>
  )
}